<template>
  <b-dropdown
    right
    no-caret
    size="sm"
    variant="light"
    class="pagination-select dropdown-columns"
  >
    <template slot="button-content">
      <i class="flaticon2-gear" style="margin: 0; padding: 0" />
    </template>
    <b-dropdown-text v-if="exportLink || printLink" class="text-muted mb-2">{{
      $t("Export")
    }}</b-dropdown-text>
    <b-dropdown-item
      v-if="exportLink"
      class="pl-2"
      :class="{ 'mb-2': !printLink }"
      @click="doPost"
      >{{ $t("Export List as XLSX") }}</b-dropdown-item
    >
    <b-dropdown-item
      v-if="printLink"
      class="mb-2 pl-2"
      @click="openPrintDialog"
      >{{ $t("Print List") }}</b-dropdown-item
    >
    <b-dropdown-form v-if="options.length">
      <p class="text-muted">{{ $t("Columns") }}</p>
      <div class="overflow">
        <div role="group">
          <draggable v-model="options" @change="onChange" @start="onStart">
            <template v-for="(item, index) in options">
              <div :key="item.key" class="cp" v-if="!item.dpIgnore">
                <b-form-checkbox
                  v-model="selected"
                  :value="index"
                  name="columns"
                  >{{
                    $t(item.label ? item.label : sc(item.key))
                  }}</b-form-checkbox
                >
              </div>
            </template>
          </draggable>
        </div>
      </div>
    </b-dropdown-form>
    <div style="display: none" v-if="exportLink">
      <form
        ref="export"
        method="POST"
        :action="exportLink"
        target="export_iframe"
      >
        <input name="json" :value="exportJson" type="hidden" />
      </form>
      <iframe name="export_iframe"></iframe>
    </div>
    <b-modal
      id="modal-printing"
      size="xl"
      :title="$t('Print Report')"
      scrollable
      v-if="printLink"
    >
      <template slot="modal-header-close">
        <span />
      </template>
      <div class="d-block">
        <div>
          <iframe
            ref="print"
            src
            scrolling="NO"
            frameborder="0"
            class="print-iframe"
          ></iframe>
        </div>
      </div>
      <template v-slot:modal-footer="{ hide }">
        <b-button variant="secondary" @click="hide()">{{
          $t("Cancel")
        }}</b-button>
        <b-button variant="success" @click="doPrint">{{
          $t("Print")
        }}</b-button>
        <!--b-button variant="info" @click="downloadPDF">{{$t('Download PDF')}}</b-button-->
      </template>
    </b-modal>
  </b-dropdown>
</template>

<script>
import draggable from "vuedraggable";
import queryString from "query-string";

import startCase from "../shared/strings";

function escape(str) {
  return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

function encode(str, encoding) {
  return escape(Buffer.from(str, encoding || "utf8").toString("base64"));
}

export default {
  name: "dropdownColumns",
  props: {
    value: {},
    fields: {},
    exportLink: {},
    printLink: {},
    exportJson: {
      default: "{}",
    },
  },
  components: { draggable },
  beforeMount() {
    console.log("fields", this.fields);
    if (this.value) {
      this.options = this.value;
      this.options.forEach((element, index) => {
        if (element.class) {
          if (element.class.indexOf("d-none") == -1) {
            this.selected.push(index);
          }
        } else {
          this.selected.push(index);
        }
      });
    }
  },
  data() {
    return {
      options: [],
      selected: [],
      temp: {},
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    queryParms() {
      const data = JSON.parse(this.exportJson);
      data.lang = this.lang;

      return encode(JSON.stringify(data));
    },
  },
  watch: {
    fields(newVal) {
      if (newVal) {
        this.selected = [];
        this.options = newVal;
        this.options.forEach((element, index) => {
          if (element.class) {
            if (element.class.indexOf("d-none") == -1) {
              this.selected.push(index);
            }
          } else {
            this.selected.push(index);
          }
        });
      }
    },
    selected(newVal) {
      for (let i = 0; i < this.options.length; i++) {
        if (newVal.includes(i)) {
          if (this.options[i].class) {
            this.options[i].class = this.options[i].class.replace(
              /d-none/g,
              ""
            );
          }
        } else {
          if (this.options[i].class.indexOf("d-none") == -1) {
            this.options[i].class =
              (this.options[i].class ? this.options[i].class : "") + " d-none";
          }
        }
      }
      this.$emit("input", this.options);
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == "modal-printing") {
        this.unbindEvent(window, "message", this.onMessageCB);
      }
    });
  },
  methods: {
    onStart() {
      this.temp = {};
      const selected = this.selected;
      for (let i = 0; i < this.options.length; i++) {
        if (selected.includes(i)) {
          this.temp[this.options[i].key] = true;
        }
      }
    },
    onChange(ev) {
      if (typeof ev.moved != "undefined") {
        const selected = [];
        for (let i = 0; i < this.options.length; i++) {
          if (this.temp[this.options[i].key]) {
            selected.push(i);
          }
        }
        this.selected = selected;
      }
    },
    sc(val) {
      return startCase(val);
    },
    doPost() {
      this.$refs.export.submit();
    },
    onMessage(e) {
      let data = {};
      try {
        data = JSON.parse(e.data);
      } catch (err) {
        // noop
      }
      if (data) {
        if (data.type && data.type == "resize" && this.$refs.print) {
          this.$refs.print.height = `${data.height}px`;
        }
      }
    },
    openPrintDialog() {
      const self = this;
      this.$bvModal.show("modal-printing");

      this.onMessageCB = this.onMessage.bind(this);
      this.bindEvent(window, "message", this.onMessageCB);

      this.$nextTick(() => {
        this.$refs.print.src = this.printLink + "?data=" + this.queryParms;
      });
    },
    doPrint() {
      this.sendMessage(JSON.stringify({ type: "print" }));
    },
    downloadPDF() {
      alert("No Implemented");
    },
    sendMessage(msg) {
      // Make sure you are sending a string, and to stringify JSON
      this.$refs.print.contentWindow.postMessage(msg, "*");
    },
    bindEvent(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent("on" + eventName, eventHandler);
      }
    },
    unbindEvent(element, eventName, eventHandler) {
      if (element.removeEventListener) {
        element.removeEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eventName, eventHandler);
      }
    },
  },
};
</script>

<style lang="scss">
.dropdown-columns .cp {
  cursor: pointer !important;
  padding: 0.25rem 0;
}
.dropdown-columns .cp > div > label {
  cursor: pointer !important;
  white-space: nowrap;
}
.overflow {
  max-height: 400px;
  overflow-y: auto;
  margin: 0 -20px;
  padding: 0 20px;
}
.print-iframe {
  width: 100%;
  border: 1px solid #ccc;
}
</style>
